import React from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import ArrowCurved from 'assets/images/tour/arrows/arrowCurved.png';
import ArrowStraight from 'assets/images/tour/arrows/arrowStraight.png';

const altT = (key) => translate('alt', key);

type Props = {
  variant?: 'straight' | 'curved' | null | undefined;
  styleName?: any;
};

const Arrow: React.FC<Props> = ({ variant, styleName }) => {
  const getImageSrc = (variant) => {
    if (variant === 'curved') return ArrowCurved;
    return ArrowStraight;
  };

  const src = getImageSrc(variant);

  return <img src={src} className={styleName} alt={altT(`Arrow ${variant}`)} />;
};

export default Arrow;
